import { IconButton, Button, DropdownMenu, Toggle } from '@nexelem/components';
import { SettingsQueueGroupList } from './SettingsQueueGroupList';
import { useCustomTranslation } from '../../../../../../hooks';
import { useGroupedQueuesStore } from '../../../store';
import { useProductionPlanSettings } from '../useProductionPlanSettings';
import { QueueColumnWidthOptions } from '../useProductionPlanSettings.types';
import { Drawer } from '@nexelem/drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faEye } from '@fortawesome/pro-light-svg-icons';

export const QueuesSettingsTab = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer');
  const applyDraftChanges = useGroupedQueuesStore((state) => state.applyDraftChanges);
  const showAll = useGroupedQueuesStore((state) => state.showAll);
  const hideAll = useGroupedQueuesStore((state) => state.hideAll);

  const columnWidth = useProductionPlanSettings((state) => state.gantt.queuesColumnWidth);
  const setColumnWidth = useProductionPlanSettings((state) => state.setGanttQueuesColumnWidth);

  return (
    <>
      <Drawer.Content className="flex flex-col overflow-hidden p-0">
        <div className="p-4">
          <div className="mb-6 flex items-center gap-6">
            <span className="text-t14-sb text-text-secondary">{tWrapper('widthOfColumn')}</span>
            <Toggle.Root value={columnWidth} onChange={setColumnWidth}>
              <Toggle.Button value={QueueColumnWidthOptions.SHORT}>{tWrapper('toggle.short')}</Toggle.Button>
              <Toggle.Button value={QueueColumnWidthOptions.WIDE}>{tWrapper('toggle.wide')}</Toggle.Button>
            </Toggle.Root>
          </div>
          <span className="text-s16">{tWrapper('order')}</span>
        </div>
        <div className="grow overflow-auto" style={{ scrollbarWidth: 'none' }}>
          <SettingsQueueGroupList />
        </div>
      </Drawer.Content>
      <Drawer.Footer>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <IconButton Icon={<FontAwesomeIcon icon={faEllipsisVertical} />} />
          </DropdownMenu.Trigger>
          <DropdownMenu.Content>
            <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faEye} />} onClick={showAll}>
              {tWrapper('showAll')}
            </DropdownMenu.Button>
            <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faEye} />} onClick={hideAll}>
              {tWrapper('hideAll')}
            </DropdownMenu.Button>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
        <Button variant="contained" onClick={applyDraftChanges}>
          {tWrapper('queuesButton')}
        </Button>
      </Drawer.Footer>
    </>
  );
};
